import * as React from "react"
const SvgImageAdd = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3.587 20.555q.588.588 1.413.588h14q.824 0 1.413-.588.587-.587.587-1.412v-7a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v7H5v-14h7a.97.97 0 0 0 .713-.288.97.97 0 0 0 .287-.712.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287H5q-.824 0-1.413.587A1.93 1.93 0 0 0 3 5.143v14q0 .825.587 1.412" />
    <path d="m14.25 12.143 3.75 5H6l3-4 2.25 3zm1.75-5h1v1q0 .424.288.712.287.288.712.288c.425 0 .52-.096.712-.288A.97.97 0 0 0 19 8.143v-1h1q.424 0 .712-.288A.97.97 0 0 0 21 6.143a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-1v-1a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713v1h-1a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712.288.288.713.288m-7.5 3q.624 0 1.063-.438Q10 9.268 10 8.643T9.562 7.58A1.45 1.45 0 0 0 8.5 7.143q-.624 0-1.063.437A1.45 1.45 0 0 0 7 8.643q0 .625.438 1.062.437.438 1.062.438" />
  </svg>
)
export default SvgImageAdd
